import { Clipboard } from '@capacitor/clipboard';
import { toastController } from '@ionic/vue';

interface UseCopyClipboardInput {
  copyValue: string;
  successMessage?: string;
  successColor?: string;
  errorMessage?: string;
  errorColor?: string;
  disableSuccessMessage?: boolean;
  disableErrorMessage?: boolean;
}

export default function () {
  const copyClipboard = async (input: UseCopyClipboardInput) => {
    try {
      await Clipboard.write({
        string: input.copyValue,
      });
      if (!input.disableSuccessMessage) {
        const toast = await toastController.create({
          header: input.successMessage || 'Copied to clipboard',
          duration: 1500,
          color: input.successColor || 'light',
        });
        await toast.present();
        return;
      }
    } catch (error) {
      if (!input.disableErrorMessage) {
        const toast = await toastController.create({
          header: input.errorMessage || 'An error occurred. Try again.',
          duration: 1500,
          color: input.errorColor || 'danger',
        });
        await toast.present();
        return;
      }
    }
  };
  return {
    copyClipboard,
  };
}
